import { useQuery } from '@tanstack/react-query';
import { getStructuralHierarchy } from "../orgPanelApiCalls";
import { useStore } from "../appStore"

const key = 'structuralHierarchy';

const useStructuralHierarchyQuery = () => {
    const orgId = useStore((state) => state.CurrentOrganizationId);
    return useQuery({ queryKey: [key], queryFn: () => getStructuralHierarchy(orgId) })
}

export { useStructuralHierarchyQuery, key };
